import { LoaderCircle, type LucideIcon } from "lucide-react";

import styles from "./IngestionStateIcon.module.css";

/**
 * The icon before a file's ingestion label or a session's ingestion badge.
 * `LoaderCircle` spins unless the viewer prefers reduced motion.
 */
export function IngestionStateIcon({ icon: Icon }: { icon: LucideIcon }) {
  return (
    <Icon
      size={12}
      aria-hidden
      className={Icon === LoaderCircle ? styles.spinning : undefined}
    />
  );
}
